import isEmpty from 'lodash/isEmpty'
import Moment from 'moment'
import * as Types from './types'

const editableHolidayAsPayload = (holiday: Types.Holiday): Types.Holiday => {
  return {
    holiday: holiday.holiday,
    id: holiday.is_synthetic ? 0 : holiday.id,
    is_active: holiday.is_active,
    name: holiday.name,
  }
}
export const holidayUpdatePayload = (holidays: Types.Holidays): Types.Holidays => {
  return holidays.filter((h: Types.Holiday) => h.is_updated &&
                                               (!h.is_synthetic || (h.is_active && !isEmpty(h.holiday))))
                 .map((h: Types.Holiday) => editableHolidayAsPayload(h))
}

export const canDelete = (h: Types.Holiday): boolean => {
  const today = Moment(new Date())
  const holiday = Moment(h.holiday)
  return holiday > today
}



// WEBPACK FOOTER //
// ./src/pages/schedules/holidays/utils.ts